import { render, staticRenderFns } from "./ZiXunType.vue?vue&type=template&id=32fe816a&scoped=true&"
import script from "./ZiXunType.vue?vue&type=script&lang=js&"
export * from "./ZiXunType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe816a",
  null
  
)

export default component.exports